(() => {
  const section = document.querySelector('.sabinat-kit-gallery');
  if (!section || section.dataset.sabiAutoplayInstalled === 'true') return;

  section.dataset.sabiAutoplayInstalled = 'true';
  const interval = 2000;
  let gallery = null;
  let slideshow = null;
  let controller = null;
  let autoplayTimer = 0;
  let resumeTimer = 0;
  let retryTimer = 0;

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const getSlides = () => slideshow ? [...slideshow.querySelectorAll('slideshow-slides > slideshow-slide')] : [];
  const stopAutoplay = () => {
    window.clearInterval(autoplayTimer);
    autoplayTimer = 0;
  };
  const resume = () => {
    if (!slideshow?.isConnected || document.hidden || slideshow.matches(':hover') || reducedMotion()) return;
    const scroller = slideshow.querySelector('slideshow-slides');
    const slides = getSlides();
    if (!scroller || slides.length < 2) return;
    stopAutoplay();
    autoplayTimer = window.setInterval(() => {
      if (!slideshow?.isConnected || document.hidden || slideshow.matches(':hover') || reducedMotion()) {
        stopAutoplay();
        return;
      }
      const activeIndex = slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false');
      const nextSlide = slides[(Math.max(activeIndex, 0) + 1) % slides.length];
      if (nextSlide) scroller.scrollTo({ left: nextSlide.offsetLeft, behavior: 'smooth' });
    }, interval);
  };
  const scheduleResume = (delay = 5000) => {
    window.clearTimeout(resumeTimer);
    resumeTimer = window.setTimeout(resume, delay);
  };
  const pauseForInteraction = () => {
    stopAutoplay();
    scheduleResume();
  };

  const bindGallery = () => {
    const nextGallery = document.querySelector('main media-gallery');
    const nextSlideshow = nextGallery?.querySelector('slideshow-component');
    if (!nextGallery) return;
    if (!nextSlideshow) {
      if (!retryTimer) retryTimer = window.setTimeout(() => { retryTimer = 0; bindGallery(); }, 100);
      return;
    }
    window.clearTimeout(retryTimer);
    retryTimer = 0;
    if (nextGallery === gallery && nextSlideshow === slideshow) return;

    window.clearTimeout(resumeTimer);
    stopAutoplay();
    controller?.abort();
    gallery = nextGallery;
    slideshow = nextSlideshow;
    controller = new AbortController();
    const { signal } = controller;

    gallery.querySelectorAll('slideshow-slide img[alt^="Testimonio"]').forEach((image) => {
      image.style.objectFit = 'contain';
    });
    const scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller || getSlides().length < 2 || reducedMotion()) return;

    slideshow.removeAttribute('autoplay');
    resume();
    gallery.addEventListener('pointerdown', pauseForInteraction, { passive: true, signal });
    gallery.addEventListener('touchstart', pauseForInteraction, { passive: true, signal });
    gallery.addEventListener('click', pauseForInteraction, { signal });
    gallery.addEventListener('keydown', pauseForInteraction, { signal });
    gallery.addEventListener('focusout', (event) => {
      if (!gallery.contains(event.relatedTarget)) scheduleResume();
    }, { signal });
    gallery.addEventListener('mouseenter', stopAutoplay, { signal });
    gallery.addEventListener('mouseleave', () => scheduleResume(250), { signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.clearTimeout(resumeTimer);
        stopAutoplay();
      } else {
        scheduleResume(250);
      }
    }, { signal });
  };

  const observer = new MutationObserver(() => {
    if (gallery && !gallery.isConnected) {
      stopAutoplay();
      controller?.abort();
      gallery = null;
      slideshow = null;
    }
    bindGallery();
  });
  customElements.whenDefined('media-gallery').then(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        bindGallery();
        observer.observe(document.body, { childList: true, subtree: true });
      });
    });
  });
})();

